<template>
    <div class="c-event-search">
        <label for="event-search">Search</label>
        <input class="c-text-search" type="text" placeholder="Name of event" id="event-search" v-model="searchValue" @keyup="updateValue" @keypress.enter="onEnterKeyPressed" />
    </div>
</template>

<script>
    export default {
        name: "SearchInput",
        data() {
            return {
                searchValue: '',
            }
        },
        mounted() {
            this.urlParamsUpdate()
        },
        methods: {
            onEnterKeyPressed() {
                this.$emit('enterKeyPressed')
            },
            urlParamsUpdate() {
                const queryString = window.location.search
                const urlParams = new URLSearchParams(queryString)

                if (urlParams.has('search')) {
                    this.searchValue = urlParams.get('search')
                    this.updateValue()
                }
            },
            updateValue() {
                // Updates search value in the VueX store found in src/vue/store/state.js
                this.$store.commit('updateField', {
                    name: 'search',
                    value: this.searchValue
                });
            }
        }
    }
</script>

<style scoped>

</style>
